import type { ReferenceCell } from 'entities/document';

type TaggableCell = ReferenceCell & { tags?: string[] };

export const canEditTags = (documentPermissions: string[] = []): boolean =>
  documentPermissions.includes('TAG_EDITOR') || documentPermissions.includes('TAG_ADMIN');

export const tableHasTags = (selectionContent?: ReferenceCell[][] | null): boolean =>
  (selectionContent ?? []).some((row) => (row ?? []).some((cell) => ((cell as TaggableCell)?.tags ?? []).length > 0));

export const showTaggerWarning = (hasTags: boolean, documentPermissions: string[] = []): boolean => !!hasTags && !canEditTags(documentPermissions);
